import { memo } from "react";
import { jsx } from "react/jsx-runtime";
//#region src/icons/icon-24-blendmode-large.tsx
/**
* icon.24.blendmode.large
*
* Keywords: droplet, drop, water, liquid, fluid, teardrop, rain, moisture
*
* ![](data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIgZmlsbD0ibm9uZSIgdmlld0JveD0iMCAwIDI0IDI0Ij48cmVjdCB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIGZpbGw9IiMwMDAiIHJ4PSI0Ii8+PHBhdGggZmlsbD0iI2ZmZiIgZD0iTTExLjM2MSAzLjI1N2EuOTE2LjkxNiAwIDAgMSAxLjI3NyAwYzEuNjM4IDEuNTcxIDUuODYyIDUuOTg3IDUuODYyIDkuNzQ4IDAgNC42NjUtMy4xNjQgNi45OS02LjUgNi45OWwtLjMxMi0uMDA2QzguNDY5IDE5Ljg0OCA1LjUgMTcuNTI1IDUuNSAxMy4wMDVjMC0zLjc2IDQuMjI0LTguMTc3IDUuODYxLTkuNzQ4bS42MzguNzc1Yy0uODA2Ljc3Ny0yLjE4NiAyLjE5OC0zLjM2OCAzLjg1OEM3LjM5NiA5LjYyNSA2LjUgMTEuNDUyIDYuNSAxMy4wMDVjMCAyLjA5NC43MDMgMy41NyAxLjY5MiA0LjUyNSAxLjAwMS45NjQgMi4zNjkgMS40NjUgMy44MDggMS40NjUgMS40NCAwIDIuODA2LS41IDMuODA3LTEuNDY1Ljk5LS45NTQgMS42OTMtMi40MzEgMS42OTMtNC41MjUgMC0xLjU1My0uODk2LTMuMzgtMi4xMzItNS4xMTVDMTQuMTg2IDYuMjMgMTIuODA1IDQuODA5IDEyIDQuMDMyIi8+PC9zdmc+)
*
* https://staging.figma.com/file/ycDPAaAih2bZY5LgXehVai/?node-id=21992-8665
*/
const Icon24BlendmodeLarge = memo(function Icon24BlendmodeLarge(props) {
	return /* @__PURE__ */ jsx("svg", {
		width: "24",
		height: "24",
		fill: "none",
		viewBox: "0 0 24 24",
		...props,
		"data-fpl-icon-size": "24L",
		children: /* @__PURE__ */ jsx("path", {
			fill: "var(--fpl-icon-color, var(--color-icon))",
			d: "M11.361 3.257a.916.916 0 0 1 1.277 0c1.638 1.571 5.862 5.987 5.862 9.748 0 4.665-3.164 6.99-6.5 6.99l-.312-.006C8.469 19.848 5.5 17.525 5.5 13.005c0-3.76 4.224-8.177 5.861-9.748m.638.775c-.806.777-2.186 2.198-3.368 3.858C7.396 9.625 6.5 11.452 6.5 13.005c0 2.094.703 3.57 1.692 4.525 1.001.964 2.369 1.465 3.808 1.465 1.44 0 2.806-.5 3.807-1.465.99-.954 1.693-2.431 1.693-4.525 0-1.553-.896-3.38-2.132-5.115C14.186 6.23 12.805 4.809 12 4.032"
		})
	});
});
//#endregion
export { Icon24BlendmodeLarge };

//# sourceMappingURL=icon-24-blendmode-large.js.map